import { ExhibitionsArchiveProps } from "./ExhibitionsArchiveProps.csharp";
import * as React from "react";
import { ExhibitionsArchivePaginationModel } from "./ExhibitionsArchivePaginationModel.csharp";
import { RangeSelector } from "../../../ReactComponents/rangeSelector/rangeSelector";
import { ExhibitionsListViewModel } from "./ExhibitionsListViewModel.csharp";
import { NewExhibitionCard } from "../../../Partials/NewExhibitionCard/NewExhibitionCard";

export class ExhibitionsArchive extends React.Component<
    ExhibitionsArchiveProps,
    { selectedYears: number[]; isLoading: boolean; yearsData: ExhibitionsListViewModel[] }
> {
    private readonly currentYear: number;

    constructor(props: ExhibitionsArchiveProps) {
        super(props);
        this.currentYear = new Date().getFullYear();

        this.state = {
            selectedYears: [props.model.startYear, props.model.endYear],
            isLoading: false,
            yearsData: props.model.data,
        };

        this.onDateChange = this.onDateChange.bind(this);
    }

    render() {
        const { minYear } = this.props.model;
        const { yearInterval } = this.props;

        const datePicker = (
            <RangeSelector
                value={this.state.selectedYears}
                maxValue={this.currentYear}
                minValue={minYear}
                step={yearInterval}
                onChange={this.onDateChange}
            />
        );

        const exhibitionsByYear = this.state.yearsData.map((year) => (
            <div key={year.title} className="ExhibitionsArchive__yearSection">
                <h2 className="ExhibitionsArchive__yearTitle">{year.title}</h2>
                <div className="ExhibitionsList__section">
                    {year.exhibitions.map((exhibition, index) => (
                        <div className="ExhibitionsList__card-wrapper" key={exhibition.pageUrl}>
                            <NewExhibitionCard
                                key={`${year.title}-${index}`}
                                title={exhibition.title}
                                subtitle={exhibition.subtitle}
                                image={exhibition.image}
                                defaultProfile={this.props.defaultProfile}
                                shortDescription={exhibition.shortDescription}
                                floor={exhibition.floor}
                                exhibitionType={exhibition.exhibitionType}
                                isComingSoon={exhibition.isComingSoon}
                                comingDateText={exhibition.comingDateText}
                                pageUrl={exhibition.pageUrl}
                                theme={exhibition.theme}
                                customThemeBackgroundColor={exhibition.customThemeBackgroundColor}
                                customThemeFontColor={exhibition.customThemeFontColor}
                                isTemporary={exhibition.isTemporary}
                                cardTranslations={exhibition.cardTranslations}
                                duration={exhibition.duration}
                            />
                        </div>
                    ))}
                </div>
            </div>
        ));

        return (
            <section className="ExhibitionsArchive">
                {datePicker}
                {exhibitionsByYear.length ? (
                    <>
                        {exhibitionsByYear}
                        {datePicker}
                    </>
                ) : (
                    <div className="ExhibitionsArchive__noResults">{this.props.translations.noResults}</div>
                )}
            </section>
        );
    }

    onDateChange(newValue: number[]) {
        const url = `${this.props.archiveUrl}?archiveId=${this.props.archiveId}&startYear=${newValue[0]}&endYear=${newValue[1]}`;

        this.setState({ isLoading: true });

        fetch(url)
            .then((response) => response.json())
            .then(
                (response) => {
                    const results = response as ExhibitionsArchivePaginationModel;

                    this.setState({
                        yearsData: results.data,
                        isLoading: false,
                        selectedYears: newValue,
                    });
                },
                (failure) => this.setState({ isLoading: false })
            );
    }
}
